$(document).ready(function(){   
	function addItem(form_id) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#'+form_id).serialize(),
        success: Shopify.onSuccess,
        error: Shopify.onError
      });
   }

   $("#add").click(function(e){   
      var elem = $(this);
      $(elem).prop("disabled", true)
      e.preventDefault();
      addItem('add-item-form');     
   });
  
   Shopify.onSuccess = function() {     
        var elem = $('#add');  
     	var quantity = parseInt(jQuery('[name="quantity"]').val(), 10) || 1;
        elem.removeAttr("disabled");
        var cartCount =  parseInt($('#cart-count').text()) + quantity;    
     
     	$('#buy-pop-up').fadeIn(1000);
     
     	$('#keep-shopping').click(function(e){
     		e.preventDefault();
          	$('#buy-pop-up').fadeOut(1000);
        })
         
    };
    
    
    Shopify.onError = function(XMLHttpRequest, textStatus) {
      // Shopify returns a description of the error in XMLHttpRequest.responseText.
      // It is JSON.
      // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
      var data = eval('(' + XMLHttpRequest.responseText + ')');
      if (!!data.message) {
        alert(data.message + '(' + data.status  + '): ' + data.description);
      } else {
        alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
      }           

      $('#add').removeAttr("disabled");
     
    };

    Shopify.fullMessagesFromErrors = function(errors) {
      var fullMessages = [];
      jQuery.each(errors, function(attribute, messages) {
        jQuery.each(messages, function(index, message) {
          fullMessages.push(attribute + ' ' + message);
        });
      });
      return fullMessages;
    };

});